'use strict';

var templates = require('../templates');
var fobclient = require('..');
var PubIdent = require('../entity').PubIdent;

module.exports = function (connection) {
  return {
    byPubIdentTypEquals: function byPubIdentTypEquals(pubidenttyp, additionalParams) {
      return templates.searchTemplate(connection)(PubIdent, 'byPubIdentTypEquals', 'pubidenttyp')(pubidenttyp, additionalParams);
    },
    bySearchRepLike: function bySearchRepLike(rep, additionalParams) {
      return templates.searchTemplate(connection)(PubIdent, 'bySearchRepLike', 'rep')(rep, additionalParams);
    },
    byWertEquals: function byWertEquals(wert, additionalParams) {
      return templates.searchTemplate(connection)(PubIdent, 'byWertEquals', 'wert')(wert, additionalParams);
    },
    byWertLike: function byWertLike(wert, additionalParams) {
      return templates.searchTemplate(connection)(PubIdent, 'byWertLike', 'wert')(wert, additionalParams);
    },
    withGenericAnd: function withGenericAnd(searchParams) {
      return templates.genericSearchTemplate(connection)(PubIdent, 'genericand')(searchParams);
    },
    byID: function byID(_id) {
      return fobclient.genericGet('pubident')(_id);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/find/pubIdent.js
// module id = cYik
// module chunks = 0